import Intro from "../../components/intro/Intro";
import Gallery from "../../components/gallery/Gallery";

const Photography = () => {
  // const food = [
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/food/coffee.jpg",
  //     alt: "a cup of coffee with leaf-shaped milk art.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/food/banana_bread/plate.jpg",
  //     alt: "a loaf of banana bread, its slices, and a glass of milk arranged in a square pattern",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/food/donuts.jpg",
  //     alt: "various bite-sized donuts arranged 4x6 in a box.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/food/brussels_sprouts_bacon.webp",
  //     alt: "brussels sprouts and bacon in a pan.",
  //   },
  // ];

  const portrait = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/makshley.jpg",
      alt: "max and ashley",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/best_day_ever_pose.jpg",
      alt: "best day ever!!",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/beach.webp",
      alt: "anika at the beach.",
    },

    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/makshley_cliff.jpg",
      alt: "max and ashley sitting on a cliff",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/max.jpg",
      alt: "max looking fresh af",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/cliff_makshley.jpg",
      alt: "max and ashley sitting on a cliff",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/wedding_celebration.jpg",
      alt: "best day ever!!",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/dad_emma.jpg",
      alt: "dad and emma dancing",
    },

    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/wedding_stare.jpg",
      alt: "best day ever!!",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/lucia_emma.jpg",
      alt: "lucia being emma",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/wedding_kiss.jpg",
      alt: "emma and seth kissing",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/emma.jpg",
      alt: "emma",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/parents.jpg",
      alt: "parents",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/anika_shat.jpg",
      alt: "anika at the beach.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/dad_emma_2.jpg",
      alt: "dad and emma dancing",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/zack.jpg",
      alt: "zack at the beach",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/thirst_trap.jpg",
      alt: "me being hot af",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/asmr2x1.png",
      alt: "me doing asmr",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/bears.webp",
      alt: "three little bears.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/me.webp",
      alt: "a close-up shot of my face.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/luthia.jpg",
      alt: "lucia staring intensely.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/emma_seth_dance.jpg",
      alt: "emma and seth dancing.",
    },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/portrait/headshot.png",
    //   alt: "me",
    // },
  ];

  const nature = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/redwood_avenue.jpg",
      alt: "the avenue of the giants.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/misty_valley.jpg",
      alt: "a misty valley, featuring a crow flying overhead.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/waves.jpg",
      alt: "ocean waves.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/flowers.webp",
      alt: "close-up shot of flowers: a stark contrast between dark green, bright yellow, and deep pink.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/snail.jpg",
      alt: "a snail in the redwoods.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/natural_bridges.jpg",
      alt: "natural bridges in oregon.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/tree.jpg",
      alt: "my favorite tree.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/raja.webp",
      alt: "red, white, and blue betta fish",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/flower.jpg",
      alt: "a perfect flower.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/swan_face.jpg",
      alt: "a close-up picture of a swan's face",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/duck.jpg",
      alt: "a double-crested cormorant",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/double_crested_cormorant.jpg",
      alt: "a close-up picture of a double-crested cormorant's face",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/cherry_blossom.jpg",
      alt: "bright pink cherry blossom tree in full bloom.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/multnomah_talls.jpg",
      alt: "a full vertical view of multnomah falls.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/petals.jpg",
      alt: "bright pink cherry blossom petals that i found in a gutter.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/split_rock_beach.jpg",
      alt: "split rock beach.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/crab.jpg",
      alt: "a crab hiding in a crevace.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/chetco_point.jpg",
      alt: "chetco point.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/azaleas.jpg",
      alt: "pink azaleas in full bloom.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/swan.jpg",
      alt: "a close-up picture of a swan's face",
    },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/nature/starfish.jpg",
    //   alt: "a starfish holding on.",
    // },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/nature/seals.jpg",
    //   alt: "seals.",
    // },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/nature/cliff.webp",
    //   alt: "a cliff",
    // },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/nature/fish.webp",
    //   alt: "fish",
    // },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/nature/commute.jpg",
    //   alt: "utah valley in the morning",
    // },
  ];

  const life = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/conquer_the_beach.jpg",
      alt: "friends and family on the beach.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/good_gather_condiments.jpg",
      alt: "Good Gather taco condiments",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/road_trip.jpg",
      alt: "a white van on a road trip.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/feet.webp",
      alt: "feet prints in sand",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/harry.webp",
      alt: "harry mack in concert.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/wallflowers.webp",
      alt: "flowers in vases hanging from a white wall.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/wavy.jpg",
      alt: "a wavy white textured pattern.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/streamers.webp",
      alt: "a close-up of multicolored streamers that were dangling from the ceiling and blowing in the wind.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/embers.webp",
      alt: "a close-up shot of burning coals: a stark contrast of pitch black and glowing red.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/beach_max.jpg",
      alt: "max's friends and family on the beach.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/ozzy_portal.jpg",
      alt: "ozzy's portal.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/kibble.jpg",
      alt: "a close-up shot of dog food: rich, brown, triangular-shaped kibble.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/food/coffee_mccausland.jpg",
      alt: "a coffee with a nice leaf and sprinkle!",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/shavings.jpg",
      alt: "a jar of wood shavings.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/food/coffee_fancy.jpg",
      alt: "a cup of coffee with leaf-shaped milk art—but better!",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/food/tomato.jpg",
      alt: "a bright red tomato resting on a pure white surface.",
    },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/food/coffee_heart.jpg",
    //   alt: "a cup of coffee with leaf-shaped milk art—but better!",
    // },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/best_day_ever.jpg",
      alt: "best day ever",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/portrait/joke.jpg",
      alt: "my artisan clown mirror! oh yeah!",
    },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/lifestyle/amphitheater.jpg",
    //   alt: "an amphitheater in the interantional rose test garden.",
    // },
    {
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/ainas_cake.jpg",
      alt: "emma's wedding cake.",
    },
  ];

  // const dogs = [
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/eevee/pumpkins.jpg",
  //     alt: "eevee running through pumpkins.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/both/standing.webp",
  //     alt: "eevee and maple standing.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/maple/pea.jpg",
  //     alt: "maple eating a pea.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/eevee/pillow.jpg",
  //     alt: "eevee on an ottoman.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/both/noses.jpg",
  //     alt: "maple and eevee sniffing under the door.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/maple/loaf.jpg",
  //     alt: "maple being a little loaf.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/eevee/ottoman.jpg",
  //     alt: "eevee on an ottoman.",
  //   },
  //   {
  //     src: "https://storage.googleapis.com/squidslippers-media/nature/dogs/both/holding_hands.webp",
  //     alt: "maple and eevee holding hands.",
  //   },
  // ];

  const product = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/hydroflask.jpg",
      alt: "a teal hydroflask.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/monocular_set.jpg",
      alt: "a monocular set.",
    },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/product/monocular.jpg",
    //   alt: "a monoculuar.",
    // },
    {
      src: "https://storage.googleapis.com/squidslippers-media/nature/rock.jpg",
      alt: "rock.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/mist.jpg",
      alt: "a tj holdman handbag.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/white.jpg",
      alt: "a tj holdman handbag.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/flame.jpg",
      alt: "a tj holdman handbag.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/food/popcorn.jpg",
      alt: "close-up shot of popcorn (some would say too close).",
    },
    // {
    //   src: "https://storage.googleapis.com/squidslippers-media/product/cmy_cube.jpg",
    //   alt: "a multicolored cube on a white background.",
    // },
    {
      src: "https://storage.googleapis.com/squidslippers-media/product/subaru.jpg",
      alt: "my new car.",
    },
  ];

  return (
    <>
      <Intro
        primary="SAY CHEEEEESE"
        secondary="I have a smartphone, a solid understanding of photography, some free time, and a few neat pictures to show for it. If you want to explore my gallery..."
        tertiary="You're in the right place."
      />

      <div className="column p01 g1">
        <h2>PORTRAIT</h2>
        <Gallery pictures={portrait} />

        <h2>NATURE</h2>
        <Gallery pictures={nature} />

        <h2>LIFE</h2>
        <Gallery pictures={life} />

        <h2>PRODUCT</h2>
        <Gallery pictures={product} />
      </div>
    </>
  );
};

export default Photography;
